import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problemas" className="border-y border-white/5 bg-ink-2" data-id="element-106" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5" data-id="element-107" data-mp="26xei5i7cgx71">
        <h2 className="pt-6 text-center font-display text-[25px] font-black text-white sm:text-4xl" data-id="element-108" data-mp="26wlewr7lgptn">
          ❌ ¿Cuánto tiempo más vas a tejer sin ganar lo que merecés?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-109" data-mp="1xzuclx2g8eqm">
          Sos creativa. Querés vivir de lo que amás. Pero después de semanas de encargos mal pagados,
          clientes que te regatean y fotos que nadie comenta… empezás a dudar.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-plata-soft" data-id="element-110" data-mp="1sywx5s8tpyst">
          No es falta de talento. No es falta de ganas. Es falta de un sistema.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-111" data-mp="3nc5wwsbki5xv">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-112" data-mp="1yz3xazfyi6hd" data-mpi={i}>
              <span aria-hidden="true" className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-bordo/30 text-sm" data-id="element-113" data-mp="1g11222wtfdb4">
                {p.emoji}
              </span>
              <div data-id="element-114" data-mp="1p427e1dux0dq">
                <h3 className="text-sm font-bold text-white" data-id="element-115" data-mp="1p0eg78vvwq26">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-116" data-mp="1k1urx1ttj26n">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 pb-12 text-center" data-id="element-117" data-mp="2vj2uriotga8p">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-118" data-mp="2vibah40o5yxq">
            ¿Y si este fuera el último mes que tejés sin un método real?
          </p>
          <p className="mt-3 text-lg font-semibold text-bordo-light" data-id="element-119" data-mp="1y36u6uq6iz8h">
            Tu primer encargo al precio justo puede ser esta semana. 🧶
          </p>
        </div>
      </div>
    </section>;
}